const isAuthSessionCookie = (cookieName: string): boolean => {
  return (
    cookieName.startsWith('__Host-authjs.') ||
    cookieName.startsWith('__Secure-authjs.') ||
    cookieName.startsWith('authjs.') ||
    cookieName.startsWith('__Host-next-auth.') ||
    cookieName.startsWith('__Secure-next-auth.') ||
    cookieName.startsWith('next-auth.')
  );
};

export default isAuthSessionCookie;
